<template>
  <span :title="platformData.name">
    <Avatar :img-url="logo" :size="imgSize" type="platform" />
  </span>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Avatar from '@/components/images/Avatar';

export default {
  name: 'PlatformEntity',
  components: { Avatar },
  props: {
    platform: {
      type: String,
      required: true,
    },
    imgSize: {
      type: [String, Number],
      default: 50,
    },
  },
  computed: {
    ...mapGetters(['platforms']),
    platformData() {
      return (
        this.platforms.find(platform => platform.id === this.platform) || {}
      );
    },
    logo() {
      return this.$lodash.get(this, 'platformData.logo.uri') || '';
    },
  },
  created() {
    this.fetchPlatforms();
  },
  methods: {
    ...mapActions(['fetchPlatforms']),
  },
};
</script>
